"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var config_1 = require("../config");
var index_1 = __importDefault(require("../Icon/index"));
var Input_1 = require("../Input");
var textArea = function (props) {
    var label = props.label, className = props.className, iconStart = props.iconStart, iconStop = props.iconStop, style = props.style, _a = props.variant, variant = _a === void 0 ? Input_1.InputVariant.Grey : _a, rest = __rest(props, ["label", "className", "iconStart", "iconStop", "style", "variant"]);
    var b = config_1.block("input");
    var cn = b({
        with_start_icon: !!iconStart,
        with_stop_icon: !!iconStop,
        white: variant === Input_1.InputVariant.White,
        grey: variant === Input_1.InputVariant.Grey,
    });
    var iconS = null;
    if (iconStart) {
        iconS = react_1.default.createElement(index_1.default, { icon: iconStart, className: "icon_start" });
    }
    var iconE = null;
    if (iconStop) {
        iconE = react_1.default.createElement(index_1.default, { icon: iconStop, className: "icon_stop" });
    }
    return (react_1.default.createElement("div", { className: b("container"), style: style },
        iconS,
        react_1.default.createElement("textarea", __assign({}, rest, { className: cn })),
        iconE));
};
exports.default = textArea;
//# sourceMappingURL=index.js.map